export default {
  methods: {
    newsPath(news) {
      return '/news/' + news.slug
    }
  }
}
